type Listener = (payload: any) => void;

class AssetLoadingBusImpl {
    private listeners: Map<string, Set<Listener>> = new Map();

    on(event: string, listener: Listener): void {
        if (!this.listeners.has(event)) this.listeners.set(event, new Set());
        this.listeners.get(event)!.add(listener);
    }

    off(event: string, listener: Listener): void {
        this.listeners.get(event)?.delete(listener);
    }

    emit(event: string, payload?: any): void {
        const set = this.listeners.get(event);
        if (!set) return;
        set.forEach(fn => {
            try { fn(payload); } catch (e) { /* swallow */ }
        });
    }
}

export const AssetLoadingBus = new AssetLoadingBusImpl();

